<template>
  <div>
    <a-table :columns="columns" :data-source="datalist" bordered
      :pagination="pagination" :scroll="{ x: 1200, y:500}" :loading="loading.table" size="small"
      key="tblMonitoring" :rowKey="(record, index) => {return index;}">
      <template slot="title">
        <div class="ant-card-head" style="padding:0px!important;">
          <div class="ant-card-head-wrapper">
            <div class="ant-card-head-title" style="padding:0px!important;">
              <div slot="title" class="d-flex flex-row justify-between nowrap">
                <span>
                <a-icon type="pic-center" />
                &nbsp;&nbsp;Monitoring Kartu Magang
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="act-grid" style="margin-top:12px">
          <a-row :gutter="{ xs: 0, lg: 8 }">
              <a-col :xs="24" :lg="24">
                <a-row :gutter="16">
                  <a-col :xs="24" :lg="20">
                    <a-form-item >
                    <a-input-search v-decorator="[
                      'search']" ref="search" @change="cari" placeholder="Pencarian ... " class="m-right" :loading="freeTexSearch.loading">
                      </a-input-search>
                    </a-form-item>
                  </a-col>
                  <a-col :xs="24" :lg="4" style="padding:4px">
                    <a-select v-model="f_jns" show-search :class="isMobile ? 'm-right margin-top w-full' : 'w-full m-right'"
                      placeholder="Pilih Kategori" :filterOption="optionFilter" @change="kategoriChange">
                      <a-select-option key="all" value="all">All Status</a-select-option>
                      <a-select-option key="available" value="available">Available</a-select-option>
                      <a-select-option key="used" value="used">Used</a-select-option>
                      <a-select-option key="Non Active" value="Non Active">Non Active</a-select-option>
                    </a-select>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
        </div>
      </template>
      <span slot="customTitle">Kode</span>
      <template slot="code" slot-scope="value, item">
        <span class="margin-left">{{ item.card_code }}</span>
      </template>
      <template slot="name" slot-scope="value, item">
        <span class="margin-left">{{ item.card_name }}</span>
      </template>
      <span slot="no" slot-scope="value, item, index">
        {{ (pagination.page - 1) * pagination.pageSize + (index + 1) }}
      </span>
      <template slot="create_dt" slot-scope="value, item">
        <span class="margin-left">{{ item.create_dt ? moment(item.create_dt).format(getDefaultDateFormat):'' }}</span>
      </template>
      <template slot="status" slot-scope="value, item">
        <a-tag :color="item.status === 'Available' ? 'green' : item.status=='Used' ? 'blue' : 'red'">
          {{ item.status }}
        </a-tag>
      </template>
      <!-- <span slot="sandi" slot-scope="value, item">
        <a-input-password v-model="item.captive_secret" :allowClear="false" placeholder="input password" />
      </span> -->
      <span slot="action" slot-scope="value, item">
        <a-button type="primary" icon="edit" @click="handleShowModPengguna(item)">
        </a-button>
      </span>
    </a-table>

    <a-modal v-if="visible.dlgpengguna" :width="800" :title="'Kartu Magang ['+modPenggunaData.card_code+']'" :visible="visible.dlgpengguna" @cancel="handleCancelModPengguna">
      <a-form class="m-form" :form="formModPengguna">
        <a-form-item label="Status Kartu">
          <a-switch checked-children="Aktif" un-checked-children="Non Aktif" 
          v-decorator="['status', {rules: [{required: true, message: 'Harus diisi!'}], initialValue: modPenggunaData.status_kartu}]"
          :checked="modPenggunaData.status_kartu" @change="changestatusKartu"
        />
        </a-form-item>
        <a-form-item label="Pengguna" v-if="rules.pengguna">
          <a-select v-decorator="['id_siswa', {rules: [{required: false, message: 'Harus diisi!'}], initialValue: modPenggunaData.id_siswa}]"
          :disabled="!rules.pengguna" allowClear placeholder="Pilih Pengguna Kartu">
            <a-select-option v-for="c in master.data_intern" :key="c.id_siswa" :value="c.id_siswa">{{ c.nama_siswa }} - {{ c.no_identitas }} - {{ c.nama_sekolah }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button key="back" @click="handleCancelModPengguna">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading.dialgsubmit" @click="handleModOk">Submit</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";

export default {
  name: "MonitoringAlokasiPekerjaan",
  props: ["spesialFor"],
  components: {
  },
  data() {
    return {
      master:{
        data_intern: []
      },
      datalist:[],
      datalist_origin:[],
      f_jns: "all",
      pagination: {
        page: 1,
        onChange: (page) => {
          this.pagination.page = page;
        },
        pageSize: 50,
        size: "default"
      },
      loading:{
        table: false,
        dialgsubmit: false
      },
      freeTexSearch: {
        timeoutSearchKetik: null,
        laoding: false
      },
      visible:{
        dlgpengguna: false
      },
      rules:{
        pengguna: true
      },
      modPenggunaData: []
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat", "getStandartFormatDate"]),
    columns(){
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const columns = [
        {
          title: 'No',
          scopedSlots: { customRender: "no" },
          width:45,
          key: 'no',
          align:"right",
        },
        {
          title: 'Status',
          key: 'status',
          align:"center",
          width: 120,
          scopedSlots: { customRender: 'status' },
        },
        {
          title: 'Tgl. buat',
          key: 'create_dt',
          align:"center",
          width: 120,
          scopedSlots: { customRender: "create_dt" },
          sorter: (a, b) => (b.create_dt ? b.create_dt : " ").localeCompare(a.create_dt ? a.create_dt : ""),
        },
        {
          key: 'code',
          width: 120,
          slots: { title: 'customTitle' },
          scopedSlots: { customRender: "code" },
          sorter: (a, b) => b.code.localeCompare(a.code),
        },
        {
          title: 'Nama',
          key: 'name',
          align:"left",
          scopedSlots: { customRender: "name" },
          sorter: (a, b) => (b.name ? b.name : " ").localeCompare(a.name ? a.name : ""),
        },
        {
          title: 'Penggunaan',
          dataIndex: 'assigned_to',
          align:"left",
          key: 'assigned_to',
          sorter: (a, b) => (b.assigned_to ? b.assigned_to : " ").localeCompare(a.assigned_to ? a.assigned_to : ""),
        },
        // {
        //   title: 'Sandi Kartu',
        //   key: 'sandi',
        //   scopedSlots: { customRender: 'sandi' },
        // },
        {
          title: '#',
          align:"center",
          fixed: "right",
          key: 'action',
          width: 50,
          scopedSlots: { customRender: "action" }
        },
      ];
      return columns;
    },
  },
  beforeCreate(){
    this.formModPengguna = this.$form.createForm(this);
  },
  created() {
  },
  methods: {
    moment,
    cari(val) {
      clearTimeout(this.freeTexSearch.timeoutSearchKetik);

      const that = this
      this.freeTexSearch.timeoutSearchKetik = setTimeout(function () {
        that.freeTexSearch.loading = true;
        that.searching(val.target.value);
        that.freeTexSearch.loading = false;
      },300)
    },
    async fetching() {
      this.loading.table = true;
      await axios({
        method: "get",
        url: this.$serviceUrl + "internship/card",
        params: {
          "X-API-KEY": this.getAuth.apikey,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        }
      })
        .then(response => {
          this.master.data_intern = response.data.data_intern;
          let tempdata = response.data.data;
          for (let i = 0; i < tempdata.length; i++) {
            tempdata[i].q_search = (tempdata[i].assigned_to ? tempdata[i].assigned_to : "").toLowerCase() + "" +
            (tempdata[i].card_code ? tempdata[i].card_code : "").toLowerCase() + "" +
            (tempdata[i].card_name ? tempdata[i].card_name : "").toLowerCase() + "" +
            (tempdata[i].status ? tempdata[i].status : "").toLowerCase() + "" +
            (tempdata[i].create_dt ? moment(tempdata[i].create_dt).format(this.getDefaultDateFormat) : "").toLowerCase()
          }
          this.datalist_origin = tempdata;
          
          //default daftar yang telah absensi
          this.f_jns = "all";
          this.searching(null);

          this.loading.table = false;
        })
        .catch(err => {
          this.loading.table = false;
          console.log(err.response);
        });
    },
    optionFilter(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    async kategoriChange(){
      this.loading.table = true;
      await this.searching(null);
      this.loading.table = false;
    },
    searching(val) {
      let src = val ? val : this.$refs.search.$el.__vue__.value;
      let f_jnsval = this.f_jns
      if(f_jnsval!="all"){
        if (src) {
          let tsearch = src.toLowerCase()
          this.datalist = _.filter(
            this.datalist_origin,
            (nav) => (nav.status ? nav.status.toLowerCase() : '') == f_jnsval.toLowerCase() && nav.q_search.indexOf(tsearch) >= 0
          );
        } else {
          this.datalist = _.filter(this.datalist_origin,
            (nav) => (nav.status ? nav.status.toLowerCase() : '') == f_jnsval.toLowerCase());
        }
      } else {
        if (src) {
          let tsearch = src.toLowerCase()
          this.datalist = _.filter(
            this.datalist_origin,
            (nav) => nav.q_search.indexOf(tsearch) >= 0
          );
        } else {
          this.datalist = this.datalist_origin
        }
      }
    },
    onChange() {
    },
    handleShowModPengguna(item){
      this.modPenggunaData = item;
      this.modPenggunaData['pengguna_old'] = item.assigned_to
      this.modPenggunaData['status_kartu'] = (item.status=='Non Active' ? false: true)
      this.rules.pengguna = (item.status=='Non Active' ? false: true)
      this.visible.dlgpengguna = true;
    },
    handleCancelModPengguna(){
      this.visible.dlgpengguna = false
    },
    handleModOk(){
      this.formModPengguna.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        this.loading.dialgsubmit = true;
        let postData = new FormData();

        postData.append("card_code", this.modPenggunaData.card_code);
        postData.append("status", this.modPenggunaData.status_kartu ? '1' : '0');
        if(values.id_siswa) postData.append("id_siswa", values.id_siswa);

        axios({
          method: "post",
          url: this.$serviceUrl + "internship/card",
          processData: false,
          data: postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey
          }
        })
          .then(response => {
            this.displayMessage("success-edit");
            this.loading.dialgsubmit = false;
            this.visible.dlgpengguna = false;
            this.fetching()
          })
          .catch(err => {
            this.loading.dialgsubmit = false;
            let response = Object.assign({}, err.response);
            if (response.data.status == false && response.data.message) {
                this.displayMessageValue("error-basic", response.data.message);
            } else {
                let responses = Object.assign({}, err.response.data);
                this.displayMessageValue("error-other", responses);
            }
          });
      })
    },
    changestatusKartu(val){
      this.modPenggunaData['status_kartu'] = val
      if(!val){
        this.rules.pengguna = false
        this.$nextTick(() => {
          this.formModPengguna.setFieldsValue({
            id_siswa: null,
          });
        })
      }else{
        this.rules.pengguna = true
      }
    }
  },
  mounted() {
    this.fetching();
  },
  activated() {
  },
  watch: {
  },
};
</script>

<style lang="less">
</style>
